import { type Material, Mesh, type Object3D, type Texture } from "three";

// WARN: use these utility functions for disposing of anything

function disposeMaterial(material: Material) {
  for (const property of Object.values(material)) {
    if ((property as Texture | null)?.isTexture)
      (property as Texture).dispose();
  }
  material.dispose();
}

export function disposeObject(root: Object3D, disposeMaterials = true) {
  const materials = new Set<Material>();
  root.traverse((object) => {
    if (!(object instanceof Mesh)) return;
    object.geometry.dispose();
    for (const material of Array.isArray(object.material)
      ? object.material
      : [object.material]) {
      materials.add(material);
    }
  });
  if (disposeMaterials) {
    for (const material of materials) disposeMaterial(material);
  }
}
